jQuery(document).ready(function($) {
  
  var path = window.location.pathname,
      searched_path = "/collections/allzweck-putzmittel",
      //////
      qab_container = $("#qab_container");
  
  if ( path == searched_path ) {
    
    var text_container = $("#shopify-section-collection-template > div:first-child .feature_text"),
        product_container = $("#shopify-section-collection-template > div:last-child");
        
    text_container.appendTo(product_container);
  }
  
  var removeInfobar = function() {
    qab_closer = $("#qab_close")
    qab_closer.click();
    console.log("test");
    window.removeEventListener("scroll", removeInfobar);
  }
  window.addEventListener("scroll", removeInfobar );
  
  
})
